export default __webpack_public_path__ + "static/media/404.47f7e860.png";